import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-3" }
const _hoisted_2 = {
  key: 0,
  class: "font-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createBlock(_component_Box, {
    color: _ctx.color,
    variant: _ctx.variant,
    class: "p-4 border border-current rounded-md shadow flex space-x-4"
  }, {
    default: _withCtx(() => [
      (_ctx.icon)
        ? (_openBlock(), _createBlock(_component_Icon, {
            key: 0,
            type: "outline",
            name: _ctx.icon,
            class: "h-6 w-6 flex-shrink-0"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        (_ctx.summary)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.summary), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["color", "variant"]))
}